import { POSITIONS } from "./constants";

// ── Helpers ────────────────────────────────────────────────────────────────

export function getMultiplierInfo(streak) {
  if (streak >= 7) return { mult:3,   label:"3x 🔥🔥🔥" };
  if (streak >= 5) return { mult:2,   label:"2x 🔥🔥"   };
  if (streak >= 3) return { mult:1.5, label:"1.5x 🔥"   };
  return { mult:1, label:null };
}

export function calcPoints(newStreak) {
  return Math.round(100 * getMultiplierInfo(newStreak).mult);
}

export function genInviteCode() {
  return Math.random().toString(36).substring(2,8).toUpperCase();
}

export function getAccuracyColor(pct) {
  if (pct >= 85) return "#4caf50";
  if (pct >= 70) return "#2196f3";
  if (pct >= 50) return "#ff9800";
  return "#e53935";
}

export function calcLevel(totalCorrect) {
  return Math.floor(totalCorrect / 10) + 1;
}

export function calcStars(correct, total) {
  if (total < 5) return 0;
  const p = correct / total;
  if (p >= 0.90) return 5;
  if (p >= 0.75) return 4;
  if (p >= 0.60) return 3;
  if (p >= 0.40) return 2;
  return 1;
}

export function checkBadges(logs, maxStreak = 0, dailyStreak = 0) {
  const totalPlayed  = logs.length;
  const totalCorrect = logs.filter(l => l.correct).length;
  const positions    = [...new Set(logs.map(l => l.position))];
  const accuracy     = totalPlayed > 0 ? totalCorrect / totalPlayed : 0;
  const clutchHit    = logs.some(l => l.correct && l.inning && Math.abs((l.teamScore||0)-(l.opponentScore||0)) <= 1);
  const earned = [];
  if (totalPlayed  >= 5)              earned.push("first_five");
  if (maxStreak    >= 5)              earned.push("hot_streak");
  if (maxStreak    >= 10)             earned.push("iron_glove");
  if (clutchHit)                      earned.push("clutch");
  if (totalPlayed  >= 20 && accuracy >= 0.80) earned.push("sharpshooter");
  if (totalPlayed  >= 100)            earned.push("century");
  if (positions.length >= 9)          earned.push("utility_player");
  if (dailyStreak  >= 3)              earned.push("dedicated");
  return earned;
}

export function getWeeklyChallenge() {
  const weekNum = Math.floor(Date.now() / (7*24*60*60*1000));
  const pos = POSITIONS[weekNum % POSITIONS.length];
  return { positionId: pos.id, label: pos.label };
}

// ── Sound Effects ──────────────────────────────────────────────────────────

export function getAudioCtx() {
  if (!window._cpAudioCtx) window._cpAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
  return window._cpAudioCtx;
}

export function playCorrectSound() {
  try {
    const ctx = getAudioCtx();
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    const cl = Math.floor(ctx.sampleRate * 0.09);
    const cb = ctx.createBuffer(1, cl, ctx.sampleRate);
    const cd = cb.getChannelData(0);
    for (let i=0;i<cl;i++) cd[i]=(Math.random()*2-1)*Math.exp(-i/(ctx.sampleRate*0.012));
    const cs = ctx.createBufferSource(); cs.buffer = cb;
    const cf = ctx.createBiquadFilter(); cf.type="bandpass"; cf.frequency.value=1400; cf.Q.value=0.6;
    const cg = ctx.createGain(); cg.gain.value=2.0;
    cs.connect(cf); cf.connect(cg); cg.connect(ctx.destination); cs.start(now);
    const qs=now+0.15, qd=2.2, ql=Math.floor(ctx.sampleRate*qd);
    const qb=ctx.createBuffer(2,ql,ctx.sampleRate);
    for(let c=0;c<2;c++){const d=qb.getChannelData(c);for(let i=0;i<ql;i++)d[i]=Math.random()*2-1;}
    const qsr=ctx.createBufferSource(); qsr.buffer=qb;
    const lp=ctx.createBiquadFilter(); lp.type="lowpass"; lp.frequency.value=700;
    const qg=ctx.createGain();
    qg.gain.setValueAtTime(0,qs); qg.gain.linearRampToValueAtTime(0.22,qs+0.5);
    qg.gain.setValueAtTime(0.22,qs+1.4); qg.gain.linearRampToValueAtTime(0,qs+qd);
    qsr.connect(lp); lp.connect(qg); qg.connect(ctx.destination); qsr.start(qs);
    [180,260,340,440,520].forEach((freq,i)=>{
      const o=ctx.createOscillator(), g=ctx.createGain(), t=qs+i*0.06;
      o.type="sawtooth"; o.frequency.setValueAtTime(freq,t); o.frequency.linearRampToValueAtTime(freq*1.4,t+1.4);
      g.gain.setValueAtTime(0,t); g.gain.linearRampToValueAtTime(0.018,t+0.2); g.gain.linearRampToValueAtTime(0,t+qd);
      o.connect(g); g.connect(ctx.destination); o.start(t); o.stop(t+qd);
    });
  } catch(e) { console.warn("Sound error:",e); }
}

export function playIncorrectSound() {
  try {
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance("Strike!");
      u.pitch=0.55; u.rate=0.8; u.volume=1.0;
      const voices = window.speechSynthesis.getVoices();
      const deep = voices.find(v=>/david|daniel|alex|mark|male|guy|fred/i.test(v.name));
      if (deep) u.voice = deep;
      window.speechSynthesis.speak(u);
    }
    const ctx=getAudioCtx(); if(ctx.state==="suspended")ctx.resume();
    const now=ctx.currentTime;
    const o=ctx.createOscillator(), g=ctx.createGain();
    o.type="square"; o.frequency.setValueAtTime(130,now); o.frequency.linearRampToValueAtTime(75,now+0.28);
    g.gain.setValueAtTime(0.35,now); g.gain.linearRampToValueAtTime(0,now+0.32);
    o.connect(g); g.connect(ctx.destination); o.start(now); o.stop(now+0.32);
  } catch(e) { console.warn("Sound error:",e); }
}
